import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    CircularProgress
} from "@mui/material";

const OrderNotesDialog = ({ 
    open, 
    onClose, 
    onSave, 
    selectedOrder,
    loading = false 
}) => {
    const { t } = useTranslation();
    const [notes, setNotes] = useState('');
    const [diners, setDiners] = useState('');

    useEffect(() => {
        if (selectedOrder && open) {
            setNotes(selectedOrder.notes || '');
            setDiners(selectedOrder.dinners || '');
        }
    }, [selectedOrder, open]);

    const handleSave = () => {
        onSave({
            notes: notes,
            dinners: parseInt(diners) || 0
        });
    };

    const handleCancel = () => {
        // Reset to original values
        setNotes(selectedOrder?.notes || '');
        setDiners(selectedOrder?.dinners || '');
        onClose();
    };

    const isValidForm = () => {
        return diners === '' || (!isNaN(parseInt(diners)) && parseInt(diners) >= 0);
    };

    return (
        <Dialog 
            open={open} 
            onClose={loading ? undefined : handleCancel}
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle>{t("pos.editOrderDetails")}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <TextField
                        label={t("pos.orderNotes")}
                        multiline
                        rows={4}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder={t("pos.orderNotesPlaceholder")}
                        fullWidth
                        disabled={loading}
                    />
                    <TextField
                        label={t("pos.numberOfDiners")}
                        type="number"
                        value={diners}
                        onChange={(e) => setDiners(e.target.value)}
                        placeholder={t("pos.numberOfDinersPlaceholder")}
                        fullWidth
                        disabled={loading}
                        inputProps={{ min: 0 }}
                        error={!isValidForm()}
                        helperText={!isValidForm() ? t("pos.validDiners") : ""}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button 
                    onClick={handleCancel}
                    variant="outlined"
                    disabled={loading}
                >
                    {t("common.cancel")}
                </Button>
                <Button 
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    disabled={loading || !isValidForm()}
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    {loading ? t("common.saving") : t("common.save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OrderNotesDialog; 